<template>
  <div class="sm:flex bg-white header-container">
    <input v-show="showHeader" v-on-clickaway="hideResults" v-on:focus="showResults = true" v-model="search" type="text" placeholder="Search here " class="flex-1 h-16 focus:border-transparent pl-5 font-semibold ml-12 lg:ml-0" id="search-box" >
    <div class="flex-1 h-16 ml-24 pl-6" v-show="!showHeader"></div>

    <!-- SEARCH -->
    <ul v-show="showResults" class="absolute mt-16 bg-white w-full pl-0 sm:ml-24 z-50" id="header-search-results">
      <li v-show="searchLoading" class="list-reset p-5">
        <Loader></Loader>
      </li>
      <li v-for="(result, i) in searchResults" :key="i" class="list-reset border-b hover:bg-grey-light" :class="{ 'border-t': i === 0 }">
        <router-link :to="result.link" class="block text-black no-underline p-3 w-full">{{ result.text }}</router-link>
      </li>
    </ul>

    <!-- CONTAINER FOR MOBILE NAV -->
    <div v-show="showHeader" class="text-center px-5 h-16 flex border-t border-b sm:border-t-0 sm:border-b-0">
      <div class="flex-1 lg:flex-none pt-6 hidden">
        <i class="fas fa-envelope"></i>
      </div>

      <!-- NAME / OFFICE -->
      <div class="flex-1 text-left px-2 my-auto self-center mw-250">
        <router-link to="/profile-v2" class="text-grey-dark no-underline text-right">
          <div class="user-name text-grey-darker text-sm font-semibold" v-if="profile">
            {{ `${profile.first_name} ${profile.surname}` }}
          </div>
          <div class="text-xs text-grey-dark" v-if="selectedOffice && selectedOffice.hasOwnProperty('name') && selectedOffice.hasOwnProperty('address_town')">
            {{ `${selectedOffice.name} (${selectedOffice.address_town})` }}
          </div>
        </router-link>
      </div>

      <!-- PROFILE PIC -->
      <div v-if="showProfilePic" class="flex lg:flex-none pt-3">
        <router-link to="/profile-v2">
          <img :src="profile.photo" @error="hasProfilePic = false" alt="profile pic" class="rounded-full w-10 h-10">
        </router-link>
      </div>

      <!-- REFERRALS -->
      <div v-if="selectedOffice.automated_referrals_permission === true" class="flex px-3">
        <div @click="openAutomaticReferrals" class="relative inline-block pt-6">
          <icon name="arrow-right-arrow-left" class="w-4 h-4 text-grey-dark hover:text-grey-darker cursor-pointer"></icon>
          <span v-if="selectedOffice.referral_applicants && selectedOffice.referral_applicants > 0" class="absolute text-center text-xxs rounded-full bg-red-dark text-white h-4 w-4 shadow" style="top: 12px; right: -12px; line-height: 16px;">{{ selectedOffice.referral_applicants > 99 ? '99+' : selectedOffice.referral_applicants }}</span>
        </div>
      </div>

      <!-- NOTIFICATIONS -->
      <div class="flex px-3 user-notification">
        <div class="relative inline-block pt-6">
          <i class="fas fa-bell text-grey-dark hover:text-grey-darker cursor-pointer" @click="toggleNotifications"></i>
          <div class="font-bold h-4 w-4 flex justify-center items-center rounded-full bg-red text-white absolute pin-t pin-r mt-3 -mx-2 text-xs" v-show="unreadNotifications > 0">
            <span v-html="unreadNotifications"></span>
          </div>
        </div>
        <notification-list v-show="showNotifications" :limit="5" class="pl-6 text-left mr-0 sm:mr-8 absolute mt-32 sm:mt-16 bg-white w-full sm:w-1/3 sm:ml-24 z-50 border-grey-dark border-solid border" id="header-notifications" />
      </div>

      <!-- SETTINGS -->
      <div class="flex self-center">
        <a class="cursor-pointer p-3 text-grey-dark hover:text-grey-darker" @click="toggleMiniMenu"><i class="fas fa-lg fa-cog"></i></a>
        <ul v-show="showMiniMenu" class="absolute mt-32 sm:mt-16 bg-white w-3/5 sm:w-1/5 pl-0 sm:ml-24 z-50 border-grey-dark border-solid border" id="header-mini-menu">
          <li v-if="selectedOffice && selectedOffice.hasOwnProperty('id') && userOfficeList.length > 0" class="list-reset p-3 border-b hover:bg-grey-light cursor-pointer"  @click="changeOffice">
            <a class="text-black no-underline hover:cursor-pointer">Change Office</a>
          </li>
          <li class="list-reset border-b hover:bg-grey-light cursor-pointer flex items-stretch">
            <a :href="ecosystemUrl" class="text-black no-underline hover:cursor-pointer w-full p-3">Ecosystem</a>
          </li>
          <li class="list-reset p-3 border-b hover:bg-grey-light cursor-pointer"  @click="logout">
            <a class="text-black no-underline hover:cursor-pointer">Logout</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="absolute pin-r pin-t m-5 sm:hidden"><a class="hover:cursor-pointer" @click="showHeader = !showHeader"><i class="fas fa-ellipsis-v"></i></a></div>

    <!-- OFFICE MODAL -->
    <modal v-if="showOfficeSelector" :scrollY="false">
      <div class="w-full flex flex-col justify-center items-center relative">
        <h2 class="p-3">Selected Office</h2>
        <select v-model="feedsOffice" class="block w-full bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 mt-2 h-10 text-sm">
          <optgroup v-for="(offices, client, i) in sortedOffices" :key="i" :label="client">
            <option v-for="(office, j) in offices" :key="j" :value="office.id">
              {{ office.name }}
            </option>
          </optgroup>
        </select>

        <button class="mt-6 bg-transparent hover:bg-tertiary active:bg-primary text-primary hover:text-white py-2 px-6 text-sm border border-tertiary hover:border-transparent rounded shadow" @click="dispatchNewOffice">Confirm</button>
        <button type="button" @click="changeModalState" class="absolute pin-t pin-r bg-black text-white -mt-8 -mr-8 rounded-full border h-8 w-8 flex justify-center items-center">
          <i class="fas fa-times" />
        </button>
      </div>
    </modal>
  </div>
</template>

<script>
import Loader from '@/components/Loader'
import { getBodyDimensions } from '@/helpers'
import NotificationList from '@/components/NotificationList'
import { mapState } from 'vuex'
import api from '@/http'
import _ from 'lodash'
import { directive as onClickaway } from 'vue-clickaway'

export default {
  name: 'SiteHeader',
  components: {
    Loader: Loader,
    NotificationList: NotificationList
  },
  directives: {
    onClickaway: onClickaway
  },
  data () {
    return {
      search: '',
      showResults: false,
      searchLoading: false,
      showHeader: true,
      showMiniMenu: false,
      showNotifications: false,
      searchResults: [],
      showOfficeSelector: false,
      hasProfilePic: true,
      sortedOffices: {}
    }
  },
  computed: {
    ...mapState(['profile', 'selectedOffice', 'userOfficeList', 'pages']),
    showProfilePic () {
      return this.hasProfilePic && this.profile && this.profile.photo
    },
    unreadNotifications () {
      if (this.profile.notifications !== undefined) {
        return this.profile.notifications.filter(n => n.read_at == null).length
      }
    },
    feedsOffice: {
      get () {
        return this.$store.state.selectedOffice.id
      },
      set (val) {
        this.$store.dispatch('setSelectedOffice', val)
      }
    },
    referralsPage () {
      let page = this.pages.find(p => p.published === 1 && p.product_module === 'App\\Members\\ProductModules\\ReferralsModule')
      if (!page) {
        return false
      }

      return '/' + page.menu.slug + '/' + page.slug
    },
    ecosystemUrl () {
      return process.env.VUE_APP_ECOSYSTEM_URL
    }
  },
  mounted () {
    let { width } = getBodyDimensions()
    if (width > 576) {
      this.showHeader = true
    } else {
      this.showHeader = false
    }
    document.addEventListener('click', this.documentClick)
    this.sortOffices()
  },
  watch: {
    search: _.debounce(function () {
      // this.searchResults = []
      this.searchLoading = true
      this.submitSearch()
    }, 250),
    userOfficeList () {
      this.sortOffices()
    }
  },
  methods: {
    submitSearch: function () {
      // send an api request with the search term
      // assign reults to results object
      api.get('search/global', { params: {
        term: this.search,
        page: 1
      }
      })
        .then(response => {
          if (response.data.results['members-pages']) {
            var results = []
            response.data.results['members-pages'].forEach((result) => {
              if (!result.assigned_network && !result.assigned_countries) {
                results.push({ text: result.title, link: result.slug })
                return
              }
              if (!result.assigned_countries && result.assigned_network === this.selectedOffice.network_id) {
                results.push({ text: result.title, link: result.slug })
                return
              }
              if (result.assigned_network === this.selectedOffice.network_id) {
                results.push({ text: result.title, link: result.slug })
                return
              }
              if (Array.isArray(result.assigned_countries) && !result.assigned_network) {
                if (result.assigned_countries.includes(this.selectedOffice.country)) {
                  results.push({ text: result.title, link: result.slug })
                }
              }
            })
            this.searchResults = results
          }
        })
        .catch((error) => {
          console.log('system', error)
        })

      this.searchLoading = false
    },
    logout: function () {
      this.$store.dispatch('setPageLoading', true)
      localStorage.removeItem('accessToken')
      localStorage.removeItem('refreshToken')
      localStorage.removeItem('office')
      localStorage.removeItem('loginFlag')
      document.querySelector('#page-wrap').classList.remove('fit-page')
      document.querySelector('#page-wrap').style.transform = ''
      this.$store.dispatch('logout')
      this.$router.replace('/login')
      this.$store.dispatch('setPageLoading', false)
    },
    toggleNotifications: function () {
      this.showMiniMenu = false
      this.showNotifications = !this.showNotifications
    },
    toggleMiniMenu: function () {
      this.showNotifications = false
      this.showMiniMenu = !this.showMiniMenu
    },
    documentClick (e) {
      let element = document.querySelector('.header-container')
      let target = e.target
      if (element && element !== target && !element.contains(target)) {
        this.showMiniMenu = false
        this.showNotifications = false
      }
    },
    changeOffice () {
      this.changeModalState()
      this.showMiniMenu = false
    },
    changeModalState () {
      this.showOfficeSelector = !this.showOfficeSelector
    },
    hideResults () {
      this.showResults = false
    },
    dispatchNewOffice () {
      console.info('dispatched active properties')
      this.$store.dispatch('fetchActiveProperties', this.selectedOffice.id)
      this.$store.dispatch('nullActiveProperties')
      this.$store.dispatch('fetchActiveAnnualReview')
      this.showOfficeSelector = !this.showOfficeSelector
    },
    sortOffices () {
      let output = {}
      for (let i = 0; i < this.userOfficeList.length; i++) {
        // Country
        let group = this.userOfficeList[i].address_country
        if (!output[group]) {
          output[group] = []
        }

        // Office
        output[group].push({
          id: this.userOfficeList[i].id,
          name: `${this.userOfficeList[i].name} (${this.userOfficeList[i].address_town})`
        })
      }

      let sortedOutput = {}
      Object.keys(output).sort().forEach(function (key) {
        sortedOutput[key] = output[key]
      })

      this.sortedOffices = sortedOutput
    },
    openAutomaticReferrals () {
      if (this.referralsPage) {
        this.$router.push(this.referralsPage + '#automatic')
      }
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#header-mini-menu, #header-notifications {
  top:0px;
  right: 0px;
}
.mw-250 {
  min-width: 250px;
}
</style>
